import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { parse, stringify } from 'query-string';
import React, { useCallback, useMemo, useState } from 'react';
import { MODE } from '../../../define/env';
import { isClient, isProfessional } from '../../../helpers/auth';
import { propId, propStr, PropTypesAuthToken, } from '../../../helpers/custom-prop-types';
import DocumentBodyState from '../../../helpers/window/DocumentBodyState';
import IframeComponent from '../Iframe/IframeComponent';
import ScriptComponent from './ScriptComponent';
/**
 * ULIZAのタグスクリプト文字列を描画するコンポーネント
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const UlizaScriptComponent = (props) => {
    const { auth, className, component, id, script, src } = props;
    const { cssLink } = DocumentBodyState.attributes;
    const [scriptClassName, setScriptClassName] = useState('');
    // 全画面表示時から通常表示に戻した時、動画の幅がおかしくなるので常に100%設定にしておく
    const iframeStyle = useMemo(() => ({ width: '100%' }), []);
    /**
     * スクリプトタグの整形
     * @type {(function(*): void)|*}
     */
    const beforeAppendChild = useCallback((fragment) => {
        // ログインユーザーに合わせて、GAイベント制御用の文字列を取得
        let identifier = 'GUEST';
        if (isClient(auth)) {
            identifier = `CLIENT_${id}`;
        }
        else if (isProfessional(auth)) {
            identifier = `PROFESSIONAL_${id}`;
        }
        const gaUserId = `${MODE}_${identifier}`;
        // DOMからscriptタグの要素を取得
        const scriptTag = fragment.firstChild;
        const { src: fragmentSrc } = scriptTag;
        if (fragmentSrc.indexOf('RequestVideoTag.aspx') !== -1) {
            // 旧仕様のスクリプトタグの場合、GETパラメータにGA計測用の値を設定する
            const url = new URL(fragmentSrc);
            const queries = parse(url.search);
            const path = `${url.origin}${url.pathname}`;
            scriptTag.src = `${path}?${stringify(Object.assign(Object.assign({}, queries), { ga_userid: gaUserId }))}`;
            // 旧仕様のスクリプトタグかつ幅100%オプションが有効な時に高さが0pxになってしまうため、高さを設定するセレクタを付与する
            if (queries.u_option_playersizeauto === '2') {
                setScriptClassName('uliza-script-v1-autosize');
            }
        }
        else if (fragmentSrc.indexOf('player-api.p.uliza.jp') !== -1) {
            scriptTag.src = fragmentSrc;
            // 最新仕様のスクリプトタグの場合、タグ内部にGA計測用の値を設定する
            scriptTag.innerHTML = `//${JSON.stringify({
                googleAnalytics: { userId: gaUserId },
            })}`;
        }
    }, [auth, id]);
    return (
    // 動的なスクリプト読み込みよるグローバル汚染を避けるため、iframe化してカプセル化してから呼び出す
    _jsx(IframeComponent
    // iframe内でもスタイルが適用されるようにしておく
    , Object.assign({ 
        // iframe内でもスタイルが適用されるようにしておく
        head: scriptClassName ? _jsx("link", { href: cssLink, rel: 'stylesheet' }) : null, style: iframeStyle }, { children: _jsx(ScriptComponent, { beforeAppendChild: beforeAppendChild, className: clsx(className, scriptClassName), component: component, script: script, src: src }) })));
};
UlizaScriptComponent.propTypes = {
    auth: PropTypesAuthToken.isRequired,
    className: propStr(),
    component: propStr(),
    id: propId(),
    script: propStr(),
    src: propStr(),
};
UlizaScriptComponent.defaultProps = {
    className: '',
    component: 'div',
    id: '',
    script: '',
    src: '',
};
export default UlizaScriptComponent;
